import BaseApiService from '../../core/services/base-api-service';

export interface TotalReport {
  namePath: string;
  description: string;
  dateCreatePdf: string;
  userKey: string;
}

class PdfListApiService extends BaseApiService {
  getAllPdf = async (): Promise<Array<TotalReport>> => {
    const response = await this.getResource(`/Reports`);
    return response;
  };
}

export default new PdfListApiService();
